/**
 * Enum representing different patient flows in the application
 * @enum {string}
 */

export enum EPatientFlow {
  Kiosk = 'kiosk',
}

/**
 * Gets the current patient flow based on the URL pathname
 * @returns {EPatientFlow | undefined} The current patient flow, or undefined if no matching flow is found
 */
export default function getCurrentPatientFlow(): [EPatientFlow | undefined, string | undefined] {
  if (window.location.pathname.startsWith('/kiosk')) {
    // TODO danielmana retrieve module's path from the context once the ui-common is updated
    const path = '/kiosk/:step';
    const step = 'login-by-contact'; // TODO danielmana use EContainerAuthPatientLoginStep
    const initialPath = path.replace(':step', step);
    return [EPatientFlow.Kiosk, initialPath];
  }
  return [undefined, undefined];
}
